var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenFrigo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 156,
    viewBox: "0 0 76 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4922 42.0546L34.6542 155.365L74.2584 132.488L75.3603 66.0981V20.4692L74.2584 19.832L33.4922 42.0546Z",
    fill: "#EAEFF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.359375 22.8946L34.6545 42.7271L74.2587 19.8325L39.9635 0L0.359375 22.8946Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.359375 135.532L34.6545 155.365V42.727L0.359375 22.8945V135.532Z",
    fill: "#C2CDDD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0078 42.2584L34.9603 42.809L74.6542 19.841L73.6453 19.2578L34.0078 42.2584Z",
    fill: "#C2CDDD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0078 154.772L34.9629 155.323V42.8084L34.0104 42.2578L34.0078 154.772Z",
    fill: "#C2CDDD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7578 43.3634V77.3684L75.362 54.9143V20.4688C75.362 20.4688 65.7286 27.9275 56.1034 33.3259C46.4777 38.7247 35.7578 43.3634 35.7578 43.3634Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7578 83.6615V156.001L75.362 133.124V61.207C75.362 61.207 69.1835 65.7313 56.8786 72.747C44.5734 79.7626 35.7578 83.6615 35.7578 83.6615Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8858 48.0213L41.7236 49.2717C41.4017 49.4577 41.1406 49.9107 41.1406 50.283V66.6572C41.1406 66.8534 41.2131 66.9884 41.3289 67.0445C41.4329 67.0948 42.244 67.565 42.244 67.565L43.8854 65.7442C44.2077 65.5578 44.4684 65.1052 44.4684 64.7325L45.2961 48.5638C45.2961 48.5638 44.4205 48.0792 44.3399 48.0099C44.2333 47.9186 44.0696 47.9149 43.8858 48.0213Z",
    fill: "#667790"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8624 48.5837L42.7002 49.8342C42.3783 50.0205 42.1172 50.4732 42.1172 50.8455V67.22C42.1172 67.5923 42.3783 67.7434 42.7002 67.5571L44.8624 66.3066C45.1843 66.1203 45.4454 65.6676 45.4454 65.2953V48.9212C45.4454 48.5485 45.1843 48.3974 44.8624 48.5837Z",
    fill: "#C2CDDD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8858 88.8532L41.7236 90.1037C41.4017 90.2897 41.1406 90.7423 41.1406 91.115V107.49C41.1406 107.686 41.2131 107.821 41.3289 107.877C41.4329 107.927 42.244 108.397 42.244 108.397L43.8854 106.576C44.2077 106.39 44.4684 105.937 44.4684 105.565L45.2961 89.3961C45.2961 89.3961 44.4205 88.9116 44.3399 88.8422C44.2333 88.7505 44.0696 88.7469 43.8858 88.8532Z",
    fill: "#667790"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8623 89.4156L42.7002 90.6661C42.3783 90.852 42.1172 91.305 42.1172 91.6773V108.052C42.1172 108.424 42.3783 108.575 42.7002 108.389L44.8623 107.139C45.1843 106.953 45.4454 106.5 45.4454 106.128V89.753C45.4454 89.3804 45.1843 89.2296 44.8623 89.4156Z",
    fill: "#C2CDDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenFrigo);
export default __webpack_public_path__ + "static/media/ben_frigo.86ba38012317e2a7eb20097c62124f04.svg";
export { ForwardRef as ReactComponent };